import { version } from 'package.json'

export default {
  appVersion: version,
  buildVersion: 0,
  bundleIdentifier: 'com.napandup.web',
}
